export const scrollToTop = () => {
    const form = document.querySelectorAll('.error-message');
    const errors = [...form]?.filter((el) => el.innerText !== '');

    const y = (errors.length && errors[0].getBoundingClientRect().top + window.scrollY) || 0;

    window.scroll({
        top: y - 250,
        behavior: 'smooth',
    });
};
